var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-detail-view',{attrs:{"loading":_vm.loading,"title":this.type === 'create'
      ? 'Создание сводного отчета по ВКК'
      : 'Сводный отчет по ВКК',"sub-title":'за 2022 год',"isUnsaved":_vm.isUnsaved && _vm.valid},on:{"onSave":_vm.save,"onRefresh":_vm.init}},[_c('v-form',{attrs:{"readonly":_vm.readonly},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('div',{staticClass:"block__content"},[_c('v-container')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }